import { render, staticRenderFns } from "./refs.vue?vue&type=template&id=4a11effe&scoped=true&"
import script from "./refs.vue?vue&type=script&lang=js&"
export * from "./refs.vue?vue&type=script&lang=js&"
import style0 from "./refs.vue?vue&type=style&index=0&id=4a11effe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a11effe",
  null
  
)

export default component.exports